import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal, Notification, Typography } from 'components';
import styles from './Notifications.module.scss';
import useError from 'hooks/useError';

function Notifications() {
  const { t } = useTranslation();
  const { error, removeError } = useError();

  const reload = useCallback(() => {
    window.location.reload();
  }, []);

  if (error?.type === 'modal') {
    return (
      <Modal className={styles.modal} dataTest="error-modal">
        <Typography
          size="m"
          className={styles.message}
          dataTest="notification-errorMessage"
        >
          {error.message}
        </Typography>
        <Button onClick={reload} dataTest="notification-btn-retry">
          {t('common:retry')}
        </Button>
      </Modal>
    );
  }

  if (error?.type === 'notification') {
    return (
      <div className={styles.notification}>
        <Notification onClose={removeError} dataTest="error-notification">
          {error.message}
        </Notification>
      </div>
    );
  }

  return null;
}

export default Notifications;
